import styledComp from 'styled-components';
import { Chip } from '@mui/material';
import { Styling, Colors } from '../../../../constants';

export const Container = styledComp.div`
  display: flex;
  flex-wrap: wrap;
  height: 64px;
  overflow: auto;
`;

export const StyledChip = styledComp(Chip)`
  padding: 0 ${Styling.DEFAULT_SPACING_HALVED}px 0 0;
  &.focused {
    &:focus, &:hover {
      background-color: ${Colors.DARK_RED};
    }
    background-color: ${Colors.RED_1};
    .MuiChip-label {
      color: ${Colors.WHITE_100};
      font-weight: bolder;
    }
    .MuiChip-deleteIcon {
      color: ${Colors.WHITE_100};
    }
  }
`;
